<template>
	<div class="p-3">
		<chat-widget-settings-content />
	</div>
</template>

<script>
import ChatWidgetSettingsContent from '@/components/Widget/ChatWidgetSettingsContent.vue';

export default {
	components: { ChatWidgetSettingsContent },
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
		}
	},
};
</script>

<style>
html, body, #app {
	margin: 0;
	padding: 0;
}
</style>
